import { render, staticRenderFns } from "./profit_merchant_list.vue?vue&type=template&id=46caaff0&scoped=true"
import script from "./profit_merchant_list.vue?vue&type=script&lang=js"
export * from "./profit_merchant_list.vue?vue&type=script&lang=js"
import style0 from "./profit_merchant_list.vue?vue&type=style&index=0&id=46caaff0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46caaff0",
  null
  
)

export default component.exports